import { __assign, __makeTemplateObject, __rest } from "tslib";
import { css } from 'emotion';
import React from 'react';
import { Icon } from '../Icon/Icon';
export var LoadingIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '5x' : _b, _c = _a.name, name = _c === void 0 ? 'cog' : _c, rest = __rest(_a, ["size", "name"]);
    return (React.createElement("div", { className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        margin: auto;\n      "], ["\n        margin: auto;\n      "]))) },
        React.createElement(Icon, __assign({ name: name, size: size, spin: true }, rest))));
};
var templateObject_1;
//# sourceMappingURL=LoadingIcon.js.map